let initState = {
    lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id'
}

export const changeLang = (state = initState, action) => {
  switch (action.type) {
    case 'CHANGE_LANGUAGE': {
      return {lang: action.payload}
    }
    default: {
      return state
    }
  }
}